import React from 'react'

export default function ReturnsPrintInStoreSwitch({
  retailer,
  printingPrice,
  printInStoreValue,
  setPrintInStore,
  useInPostRetailerPageNewCopy,
}) {
  return (
    <div className="parcel-details__print-in-store-option">
        {<div className="parcel-details__print-in-store-checkbox-container">
            <label className="checkbox-label">{!printInStoreValue ? 'Print at home' : `Print ${useInPostRetailerPageNewCopy ? "at shop" : "in store"}${printingPrice > 0 ? ` - just £${printingPrice.toFixed(2)}` : ''}`}</label>
            {retailer?.enablePrintAtHome && retailer?.enablePrintInStore && (
              <a onClick={(e) => {
                    e.preventDefault();
                    setPrintInStore(!printInStoreValue);
                }}
                href="">
                  {`${printInStoreValue ? "Print at home" : `Print ${useInPostRetailerPageNewCopy ? "at shop" : "in store"}${printingPrice > 0 ? ` - just £${printingPrice.toFixed(2)}` : ''}`}`}
              </a>
            )}
        </div>}
    </div>
  )
}
